module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kne-modal-backdrop",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.close()
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.init) ? _c('div', {
    staticClass: "card col-12 col-md-8 offset-md-2 kne-modal"
  }, [(_vm.title || _vm.closable) ? _c('h4', {
    staticClass: "card-title text-center py-2 px-3"
  }, [(_vm.title) ? _c('span', [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.closable) ? _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.close('x')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-block px-0 pt-0"
  }, [_vm._t("default")], 2)]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c7f1ffe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 829
// module chunks = 1